import { combineReducers } from 'redux';
import isOffline from '../offline/offlineSlice';
import snackbarSlice from '../notifications/snackbarSlice';

export default () =>
    combineReducers({
        isOffline,
        snackbarSlice,
    });